// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2KdrP","containerItemsCenter":"Skeleton_containerItemsCenter__22aGl"};